import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, Settings, User, Vault } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { usePersonnalisation } from '../hooks/usePersonnalisation';

// La barre reste courte : Association, Sponsors et les événements se
// rejoignent depuis l'accès rapide et les cartes de l'accueil — les pouces ne
// visent bien que quatre ou cinq cibles, et une barre qui en porte sept se
// touche de travers.
const liensPublics = [{ to: '/', icon: Home, label: 'Accueil' }];

export default function BottomNav() {
  const { user, aLeDroit } = useAuth();
  const perso = usePersonnalisation();

  const estAdmin = user?.roles?.includes('ROLE_ADMIN') === true;
  // Le coffre suit l'option de la plateforme : souscrite, ou ouverte d'office
  // en essai et pendant une gratuité. Tant qu'elle n'est pas lue, on n'efface
  // rien — la barre ne doit pas clignoter au chargement.
  const vaultOuvert = (perso?.options as any)?.vault !== false;

  const navItems = [
    ...liensPublics,
    // L'accès rapide plutôt que l'annuaire : c'est le carrefour de tous les
    // écrans du membre — les fiches s'y retrouvent aussi, sans monopoliser
    // une place de la barre. Même porte que le grand menu : les bénévoles
    // et au-delà, pas un compte sponsor.
    ...(user?.roles?.some((r: string) => ['ROLE_VOLUNTEER', 'ROLE_BUREAU', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'].includes(r))
      ? [{ to: '/acces-rapide', icon: LayoutGrid, label: 'Accès rapide' }]
      : []),
    // Le coffre sur le pouce : c'est en déplacement qu'on cherche un mot de
    // passe. Même règle que le grand menu — le droit de la grille et l'option.
    ...(aLeDroit('voir_vault') && vaultOuvert
      ? [{ to: '/admin/vault', icon: Vault, label: 'Coffre-fort' }]
      : []),
    // L'administration, juste avant « Mon espace ».
    //
    // Ces sept ecrans vivent dans le menu lateral, que le telephone n'a pas :
    // ils y etaient donc introuvables, et un president qui voulait verifier
    // ses sauvegardes depuis la salle des fetes devait attendre d'etre rentre
    // chez lui. Une seule entree pour tous, parce que la barre ne porte pas
    // sept cibles — la page qu'elle ouvre les presente en cartes.
    ...(estAdmin ? [{ to: '/administration', icon: Settings, label: 'Administration' }] : []),
    { to: '/informations', icon: User, label: 'Mon espace' },
  ];

  return (
    <nav className="sticky bottom-0 z-50 bg-white border-t border-gray-100 safe-area-inset-bottom">
      <ul className="flex justify-around items-center py-2">
        {navItems.map(({ to, icon: Icon, label }) => (
          <li key={to} className="min-w-0">
            <NavLink
              to={to}
              end={to === '/'}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 px-1.5 py-1 rounded-xl transition-colors ${
                  isActive
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-gray-400 hover:text-gray-600'
                }`
              }
            >
              <Icon className="w-6 h-6" />
              <span className="text-[10px] font-medium leading-tight">{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
